// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://backend-api-itt1.onrender.com/api';

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_BASE_URL}/auth/login/`,

  // Property
  PROPERTY_LIST: `${API_BASE_URL}/property/`,
  PROPERTY_CREATE: `${API_BASE_URL}/property/create/`,
  PROPERTY_UPDATE: (id) => `${API_BASE_URL}/property/${id}/update/`,
  PROPERTY_DELETE: (id) => `${API_BASE_URL}/property/${id}/delete/`,
  PROPERTY_BULK_IMPORT: `${API_BASE_URL}/property/bulk-import/`,
  PROPERTY_BULK_EXPORT: `${API_BASE_URL}/property/bulk-export/`,
  PROPERTY_DOWNLOAD_TEMPLATE: `${API_BASE_URL}/property/download-template/`,

  // Property Maps
  PROPERTY_MAPS_LIST: `${API_BASE_URL}/property/maps/`,
  PROPERTY_MAPS_CREATE: `${API_BASE_URL}/property/maps/`,
  PROPERTY_MAPS_DETAIL: (id) => `${API_BASE_URL}/property/maps/${id}/`,
  PROPERTY_MAPS_UPDATE: (id) => `${API_BASE_URL}/property/maps/${id}/`,
  PROPERTY_MAPS_PATCH: (id) => `${API_BASE_URL}/property/maps/${id}/`,
  PROPERTY_MAPS_DELETE: (id) => `${API_BASE_URL}/property/maps/${id}/`,

  // Clients
  CLIENTS_LIST: `${API_BASE_URL}/clients/`,
  CLIENTS_DETAIL: (id) => `${API_BASE_URL}/clients/${id}/`,
  CLIENTS_CREATE: `${API_BASE_URL}/clients/create/`,
  CLIENTS_UPDATE: (id) => `${API_BASE_URL}/clients/${id}/update/`,
  CLIENTS_DELETE: (id) => `${API_BASE_URL}/clients/${id}/delete/`,
  CLIENTS_BULK_IMPORT: `${API_BASE_URL}/clients/bulk-import/`,
  CLIENTS_BULK_EXPORT: `${API_BASE_URL}/clients/bulk-export/`,
  CLIENTS_DOWNLOAD_TEMPLATE: `${API_BASE_URL}/clients/download-template/`,

  // Roles
  ROLES_LIST: `${API_BASE_URL}/roles/`,
  ROLES_CREATE: `${API_BASE_URL}/roles/create/`,
  ROLES_UPDATE: (id) => `${API_BASE_URL}/roles/${id}/update/`,
  ROLES_DELETE: (id) => `${API_BASE_URL}/roles/${id}/delete/`,
  ROLES_DETAIL: (id) => `${API_BASE_URL}/roles/${id}/`,

  // User Roles
  USER_ROLES_LIST: `${API_BASE_URL}/roles/user-roles/`,
  USER_ROLES_CREATE: `${API_BASE_URL}/roles/user-roles/create/`,
  USER_ROLES_UPDATE: (id) => `${API_BASE_URL}/roles/user-roles/${id}/update/`,
  USER_ROLES_DELETE: (id) => `${API_BASE_URL}/roles/user-roles/${id}/delete/`,

  // Direct Surveyors endpoint (fallback)
  SURVEYORS_LIST: `${API_BASE_URL}/survey/surveyors/`,

  // Permissions
  PERMISSIONS_LIST: `${API_BASE_URL}/permissions/`,


  // Survey Assignment
  SURVEY_ASSIGN: `${API_BASE_URL}/survey/assign/`,
  SURVEY_REASSIGN: (id) => `${API_BASE_URL}/survey/${id}/reassign/`,
  // Surveys
  SURVEYS_LIST: `${API_BASE_URL}/survey/`,
  SURVEY_DETAIL: (id) => `${API_BASE_URL}/survey/${id}/`,

  // Survey Swap Requests
  SWAP_REQUESTS_LIST: `${API_BASE_URL}/survey/swap-requests/`,
  SWAP_REQUEST_ACTION: (id) => `${API_BASE_URL}/survey/swap-requests/${id}/action/`,

  // Survey Comments (per-survey)
  SURVEY_COMMENTS_LIST: (surveyId) => `${API_BASE_URL}/survey/${surveyId}/comments/list/`,

  // Contacts - Customers
  CUSTOMERS_LIST: `${API_BASE_URL}/contacts/customers/`,
  CUSTOMERS_CREATE: `${API_BASE_URL}/contacts/customers/create/`,
  CUSTOMERS_DETAIL: (id) => `${API_BASE_URL}/contacts/customers/${id}/`,
  CUSTOMERS_UPDATE: (id) => `${API_BASE_URL}/contacts/customers/${id}/update/`,
  CUSTOMERS_DELETE: (id) => `${API_BASE_URL}/contacts/customers/${id}/delete/`,

  // Contacts - Suppliers
  SUPPLIERS_LIST: `${API_BASE_URL}/contacts/suppliers/`,
  SUPPLIERS_CREATE: `${API_BASE_URL}/contacts/suppliers/create/`,
  SUPPLIERS_DETAIL: (id) => `${API_BASE_URL}/contacts/suppliers/${id}/`,
  SUPPLIERS_UPDATE: (id) => `${API_BASE_URL}/contacts/suppliers/${id}/update/`,
  SUPPLIERS_DELETE: (id) => `${API_BASE_URL}/contacts/suppliers/${id}/delete/`,

  // Inventory - Sales Catalog
  SALES_CATALOG_LIST: `${API_BASE_URL}/inventory/sales-catalog/`,
  SALES_CATALOG_CREATE: `${API_BASE_URL}/inventory/sales-catalog/create/`,
  SALES_CATALOG_DETAIL: (id) => `${API_BASE_URL}/inventory/sales-catalog/${id}/`,
  SALES_CATALOG_UPDATE: (id) => `${API_BASE_URL}/inventory/sales-catalog/${id}/update/`,
  SALES_CATALOG_DELETE: (id) => `${API_BASE_URL}/inventory/sales-catalog/${id}/delete/`,

  // Inventory - Purchased Items
  PURCHASED_ITEMS_LIST: `${API_BASE_URL}/inventory/purchased-items/`,
  PURCHASED_ITEMS_CREATE: `${API_BASE_URL}/inventory/purchased-items/create/`,
  PURCHASED_ITEMS_DETAIL: (id) => `${API_BASE_URL}/inventory/purchased-items/${id}/`,
  PURCHASED_ITEMS_UPDATE: (id) => `${API_BASE_URL}/inventory/purchased-items/${id}/update/`,
  PURCHASED_ITEMS_DELETE: (id) => `${API_BASE_URL}/inventory/purchased-items/${id}/delete/`,

  // Contacts - Employees
  EMPLOYEES_LIST: `${API_BASE_URL}/contacts/employees/`,
  EMPLOYEES_CREATE: `${API_BASE_URL}/contacts/employees/create/`,
  EMPLOYEES_DETAIL: (id) => `${API_BASE_URL}/contacts/employees/${id}/`,
  EMPLOYEES_UPDATE: (id) => `${API_BASE_URL}/contacts/employees/${id}/update/`,
  EMPLOYEES_DELETE: (id) => `${API_BASE_URL}/contacts/employees/${id}/delete/`,

  // HR - Payroll
  PAYROLL_LIST: `${API_BASE_URL}/hr/payroll/`,
  PAYROLL_CREATE: `${API_BASE_URL}/hr/payroll/create/`,
  PAYROLL_DETAIL: (id) => `${API_BASE_URL}/hr/payroll/${id}/`,
  PAYROLL_UPDATE: (id) => `${API_BASE_URL}/hr/payroll/${id}/update/`,
  PAYROLL_DELETE: (id) => `${API_BASE_URL}/hr/payroll/${id}/delete/`,

  // HR - Attendance
  ATTENDANCE_LIST: `${API_BASE_URL}/hr/attendance/`,
  ATTENDANCE_CREATE: `${API_BASE_URL}/hr/attendance/create/`,
  ATTENDANCE_DETAIL: (id) => `${API_BASE_URL}/hr/attendance/${id}/`,
  ATTENDANCE_UPDATE: (id) => `${API_BASE_URL}/hr/attendance/${id}/update/`,
  ATTENDANCE_DELETE: (id) => `${API_BASE_URL}/hr/attendance/${id}/delete/`,

  // Sales - Invoices
  INVOICES_LIST: `${API_BASE_URL}/sales/invoices/`,
  INVOICES_CREATE: `${API_BASE_URL}/sales/invoices/`,
  INVOICES_DETAIL: (id) => `${API_BASE_URL}/sales/invoices/${id}/`,
  INVOICES_UPDATE: (id) => `${API_BASE_URL}/sales/invoices/${id}/`,
  INVOICES_DELETE: (id) => `${API_BASE_URL}/sales/invoices/${id}/`,
  INVOICES_GENERATE_NUMBER: (id) => `${API_BASE_URL}/sales/invoices/${id}/generate_invoice_number/`,
  INVOICES_MARK_PAID: (id) => `${API_BASE_URL}/sales/invoices/${id}/mark_as_paid/`,
  INVOICES_PAYMENT_STATUS: (id) => `${API_BASE_URL}/sales/invoices/${id}/payment_status/`,

  // Sales - Quotes
  QUOTES_LIST: `${API_BASE_URL}/sales/quotes/`,
  QUOTES_CREATE: `${API_BASE_URL}/sales/quotes/`,
  QUOTES_DETAIL: (id) => `${API_BASE_URL}/sales/quotes/${id}/`,
  QUOTES_UPDATE: (id) => `${API_BASE_URL}/sales/quotes/${id}/`,
  QUOTES_DELETE: (id) => `${API_BASE_URL}/sales/quotes/${id}/`,
  QUOTES_CONVERT_TO_INVOICE: (id) => `${API_BASE_URL}/sales/quotes/${id}/convert_to_invoice/`,
  QUOTES_MARK_ACCEPTED: (id) => `${API_BASE_URL}/sales/quotes/${id}/mark_as_accepted/`,

  // Sales - Estimates
  ESTIMATES_LIST: `${API_BASE_URL}/sales/estimates/`,
  ESTIMATES_CREATE: `${API_BASE_URL}/sales/estimates/`,
  ESTIMATES_DETAIL: (id) => `${API_BASE_URL}/sales/estimates/${id}/`,
  ESTIMATES_UPDATE: (id) => `${API_BASE_URL}/sales/estimates/${id}/`,
  ESTIMATES_DELETE: (id) => `${API_BASE_URL}/sales/estimates/${id}/`,
  ESTIMATES_GENERATE_NUMBER: (id) => `${API_BASE_URL}/sales/estimates/${id}/generate_invoice_number/`,
  ESTIMATES_MARK_PAID: (id) => `${API_BASE_URL}/sales/estimates/${id}/mark_as_paid/`,
  ESTIMATES_PAYMENT_STATUS: (id) => `${API_BASE_URL}/sales/estimates/${id}/payment_status/`,

  // Company Profile
  COMPANY_PROFILE_LIST: `${API_BASE_URL}/company-profile/`,
  COMPANY_PROFILE_CREATE: `${API_BASE_URL}/company-profile/`,
  COMPANY_PROFILE_DETAIL: (id) => `${API_BASE_URL}/company-profile/${id}/`,
  COMPANY_PROFILE_UPDATE: (id) => `${API_BASE_URL}/company-profile/${id}/`,
  COMPANY_PROFILE_PATCH: (id) => `${API_BASE_URL}/company-profile/${id}/`,
  COMPANY_PROFILE_DELETE: (id) => `${API_BASE_URL}/company-profile/${id}/`,

  // Banking - Utilities (Cashflow)
  UTILITIES_LIST: `${API_BASE_URL}/banking/utilities/`,
  UTILITIES_CREATE: `${API_BASE_URL}/banking/utilities/`,
  UTILITIES_DETAIL: (id) => `${API_BASE_URL}/banking/utilities/${id}/`,
  UTILITIES_UPDATE: (id) => `${API_BASE_URL}/banking/utilities/${id}/`,
  UTILITIES_PATCH: (id) => `${API_BASE_URL}/banking/utilities/${id}/`,
  UTILITIES_DELETE: (id) => `${API_BASE_URL}/banking/utilities/${id}/`,

  // Banking - Bank Records/Transactions
  BANK_RECORDS_LIST: `${API_BASE_URL}/banking/bank-records/`,
  BANK_RECORDS_CREATE: `${API_BASE_URL}/banking/bank-records/`,
  BANK_RECORDS_DETAIL: (id) => `${API_BASE_URL}/banking/bank-records/${id}/`,
  BANK_RECORDS_UPDATE: (id) => `${API_BASE_URL}/banking/bank-records/${id}/`,
  BANK_RECORDS_PATCH: (id) => `${API_BASE_URL}/banking/bank-records/${id}/`,
  BANK_RECORDS_DELETE: (id) => `${API_BASE_URL}/banking/bank-records/${id}/`,
  BANK_IMPORT: `${API_BASE_URL}/banking/import/`,
  BANK_EXPORT: `${API_BASE_URL}/banking/export/`,
  // Template download endpoint: https://backend-api-itt1.onrender.com/api/banking/template/
  // Format parameter is optional (defaults to CSV): ?format=csv or ?format=excel
  BANK_TEMPLATE: `${API_BASE_URL}/banking/template/`,

  // Sales - Bills of Supply
  BILLS_OF_SUPPLY_LIST: `${API_BASE_URL}/sales/bills-of-supply/`,
  BILLS_OF_SUPPLY_DETAIL: (id) => `${API_BASE_URL}/sales/bills-of-supply/${id}/`,
  BILLS_OF_SUPPLY_DELETE: (id) => `${API_BASE_URL}/sales/bills-of-supply/${id}/`,

  // Sales - Credit Notes
  CREDIT_NOTES_LIST: `${API_BASE_URL}/sales/credit-notes/`,
  CREDIT_NOTES_DETAIL: (id) => `${API_BASE_URL}/sales/credit-notes/${id}/`,
  CREDIT_NOTES_UPDATE: (id) => `${API_BASE_URL}/sales/credit-notes/${id}/`,
  CREDIT_NOTES_DELETE: (id) => `${API_BASE_URL}/sales/credit-notes/${id}/`,

  // Sales - Delivery Challans
  DELIVERY_CHALLANS_LIST: `${API_BASE_URL}/sales/delivery-challans/`,
  DELIVERY_CHALLANS_DETAIL: (id) => `${API_BASE_URL}/sales/delivery-challans/${id}/`,
  DELIVERY_CHALLANS_UPDATE: (id) => `${API_BASE_URL}/sales/delivery-challans/${id}/`,
  DELIVERY_CHALLANS_DELETE: (id) => `${API_BASE_URL}/sales/delivery-challans/${id}/`,

  // Sales - Receipts
  RECEIPTS_LIST: `${API_BASE_URL}/sales/receipts/`,
  RECEIPTS_DETAIL: (id) => `${API_BASE_URL}/sales/receipts/${id}/`,
  RECEIPTS_UPDATE: (id) => `${API_BASE_URL}/sales/receipts/${id}/`,
  RECEIPTS_DELETE: (id) => `${API_BASE_URL}/sales/receipts/${id}/`,
  RECEIPTS_MARK_COMPLETED: (id) => `${API_BASE_URL}/sales/receipts/${id}/mark_as_completed/`,

  // Sales - Receivables
  RECEIVABLES_LIST: `${API_BASE_URL}/sales/receivables/`,
  RECEIVABLES_DETAIL: (id) => `${API_BASE_URL}/sales/receivables/${id}/`,
  RECEIVABLES_UPDATE: (id) => `${API_BASE_URL}/sales/receivables/${id}/`,
  RECEIVABLES_DELETE: (id) => `${API_BASE_URL}/sales/receivables/${id}/`,
  RECEIVABLES_RECORD_PAYMENT: (id) => `${API_BASE_URL}/sales/receivables/${id}/record_payment/`,
  RECEIVABLES_AGED: `${API_BASE_URL}/sales/receivables/aged_receivables/`,
  RECEIVABLES_OVERDUE: `${API_BASE_URL}/sales/receivables/overdue_receivables/`,

  // Sales - Sales Register
  SALES_REGISTER_LIST: `${API_BASE_URL}/sales/sales-register/`,
  SALES_REGISTER_DETAIL: (id) => `${API_BASE_URL}/sales/sales-register/${id}/`,
  SALES_REGISTER_UPDATE: (id) => `${API_BASE_URL}/sales/sales-register/${id}/`,
  SALES_REGISTER_DELETE: (id) => `${API_BASE_URL}/sales/sales-register/${id}/`,

  // Purchases - Purchase Orders
  PURCHASE_ORDERS_LIST: `${API_BASE_URL}/purchases/purchase-orders/`,
  PURCHASE_ORDERS_CREATE: `${API_BASE_URL}/purchases/purchase-orders/`,
  PURCHASE_ORDERS_DETAIL: (id) => `${API_BASE_URL}/purchases/purchase-orders/${id}/`,
  PURCHASE_ORDERS_UPDATE: (id) => `${API_BASE_URL}/purchases/purchase-orders/${id}/`,
  PURCHASE_ORDERS_DELETE: (id) => `${API_BASE_URL}/purchases/purchase-orders/${id}/`,
  PURCHASE_ORDERS_GENERATE_NUMBER: (id) => `${API_BASE_URL}/purchases/purchase-orders/${id}/generate_po_number/`,
  PURCHASE_ORDERS_MARK_CONFIRMED: (id) => `${API_BASE_URL}/purchases/purchase-orders/${id}/mark_as_confirmed/`,

  // Purchases - Debit Notes
  DEBIT_NOTES_LIST: `${API_BASE_URL}/purchases/debit-notes/`,
  DEBIT_NOTES_CREATE: `${API_BASE_URL}/purchases/debit-notes/`,
  DEBIT_NOTES_DETAIL: (id) => `${API_BASE_URL}/purchases/debit-notes/${id}/`,
  DEBIT_NOTES_UPDATE: (id) => `${API_BASE_URL}/purchases/debit-notes/${id}/`,
  DEBIT_NOTES_DELETE: (id) => `${API_BASE_URL}/purchases/debit-notes/${id}/`,
  DEBIT_NOTES_GENERATE_NUMBER: (id) => `${API_BASE_URL}/purchases/debit-notes/${id}/generate_debit_note_number/`,
  DEBIT_NOTES_MARK_APPROVED: (id) => `${API_BASE_URL}/purchases/debit-notes/${id}/mark_as_approved/`,

  // Purchases - Voucher Payments
  VOUCHER_PAYMENTS_LIST: `${API_BASE_URL}/purchases/voucher-payments/`,
  VOUCHER_PAYMENTS_CREATE: `${API_BASE_URL}/purchases/voucher-payments/`,
  VOUCHER_PAYMENTS_DETAIL: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/`,
  VOUCHER_PAYMENTS_UPDATE: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/`,
  VOUCHER_PAYMENTS_DELETE: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/`,
  VOUCHER_PAYMENTS_GENERATE_NUMBER: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/generate_voucher_number/`,
  VOUCHER_PAYMENTS_MARK_COMPLETED: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/mark_as_completed/`,
  VOUCHER_PAYMENTS_MARK_PENDING: (id) => `${API_BASE_URL}/purchases/voucher-payments/${id}/mark_as_pending/`,

  // Purchases - Salary Payments
  SALARY_PAYMENTS_LIST: `${API_BASE_URL}/purchases/salary-payments/`,
  SALARY_PAYMENTS_CREATE: `${API_BASE_URL}/purchases/salary-payments/`,
  SALARY_PAYMENTS_DETAIL: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/`,
  SALARY_PAYMENTS_UPDATE: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/`,
  SALARY_PAYMENTS_DELETE: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/`,
  SALARY_PAYMENTS_GENERATE_NUMBER: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/generate_salary_voucher_number/`,
  SALARY_PAYMENTS_MARK_COMPLETED: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/mark_as_completed/`,
  SALARY_PAYMENTS_CALCULATE_NET_PAY: (id) => `${API_BASE_URL}/purchases/salary-payments/${id}/calculate_net_pay/`,

  // Purchases - Expense Register
  EXPENSE_REGISTER_LIST: `${API_BASE_URL}/purchases/expense-register/`,
  EXPENSE_REGISTER_CREATE: `${API_BASE_URL}/purchases/expense-register/`,
  EXPENSE_REGISTER_DETAIL: (id) => `${API_BASE_URL}/purchases/expense-register/${id}/`,
  EXPENSE_REGISTER_UPDATE: (id) => `${API_BASE_URL}/purchases/expense-register/${id}/`,
  EXPENSE_REGISTER_DELETE: (id) => `${API_BASE_URL}/purchases/expense-register/${id}/`,

  // Purchases - Surveyor Expenses
  EXPENSES_LIST: `${API_BASE_URL}/purchases/expenses/`,
  EXPENSES_CREATE: `${API_BASE_URL}/purchases/expenses/`,
  EXPENSES_DETAIL: (id) => `${API_BASE_URL}/purchases/expenses/${id}/`,
  EXPENSES_UPDATE: (id) => `${API_BASE_URL}/purchases/expenses/${id}/`,
  EXPENSES_DELETE: (id) => `${API_BASE_URL}/purchases/expenses/${id}/`,
  EXPENSES_SUBMIT: (id) => `${API_BASE_URL}/purchases/expenses/${id}/submit_for_approval/`,
  EXPENSES_APPROVE: (id) => `${API_BASE_URL}/purchases/expenses/${id}/approve/`,
  EXPENSES_REJECT: (id) => `${API_BASE_URL}/purchases/expenses/${id}/reject/`,
  EXPENSES_MARK_PAID: (id) => `${API_BASE_URL}/purchases/expenses/${id}/mark_as_paid/`,
  EXPENSES_MY: `${API_BASE_URL}/purchases/expenses/my_expenses/`,
  EXPENSES_PENDING: `${API_BASE_URL}/purchases/expenses/pending_approval/`,
  EXPENSES_SUMMARY: `${API_BASE_URL}/purchases/expenses/summary/`,
  EXPENSES_BY_DATE_RANGE: `${API_BASE_URL}/purchases/expenses/by_date_range/`,

  // Purchases - Purchase Invoices
  PURCHASE_INVOICES_LIST: `${API_BASE_URL}/purchases/purchase-invoices/`,
  PURCHASE_INVOICES_DETAIL: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/`,
  PURCHASE_INVOICES_UPDATE: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/`,
  PURCHASE_INVOICES_DELETE: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/`,
  PURCHASE_INVOICES_GENERATE_NUMBER: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/generate_invoice_number/`,
  PURCHASE_INVOICES_MARK_PAID: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/mark_as_paid/`,
  PURCHASE_INVOICES_MARK_SENT: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/mark_as_sent/`,
  PURCHASE_INVOICES_PAYMENT_STATUS: (id) => `${API_BASE_URL}/purchases/purchase-invoices/${id}/payment_status/`,

  // Reports - Definitions
  REPORTS_DEFINITIONS_LIST: `${API_BASE_URL}/reports/definitions/`,
  REPORTS_DEFINITIONS_DETAIL: (key) => `${API_BASE_URL}/reports/definitions/${key}/`,

  // Reports - Preview
  REPORTS_PREVIEW: `${API_BASE_URL}/reports/preview/`,

  // Reports - Jobs
  REPORTS_JOBS_LIST: `${API_BASE_URL}/reports/jobs/`,
  REPORTS_JOBS_CREATE: `${API_BASE_URL}/reports/jobs/`,
  REPORTS_JOBS_DETAIL: (id) => `${API_BASE_URL}/reports/jobs/${id}/`,
  REPORTS_JOBS_CANCEL: (id) => `${API_BASE_URL}/reports/jobs/${id}/cancel/`,
  REPORTS_JOBS_DOWNLOAD: (id) => `${API_BASE_URL}/reports/jobs/${id}/download/`,

  // Reports - Filters
  REPORTS_FILTERS_OPTIONS: `${API_BASE_URL}/reports/filters/options/`,
  REPORTS_FILTERS_LIST: `${API_BASE_URL}/reports/filters/`,
  REPORTS_FILTERS_CREATE: `${API_BASE_URL}/reports/filters/`,
  REPORTS_FILTERS_DELETE: (id) => `${API_BASE_URL}/reports/filters/${id}/`,

  // Analytics
  ANALYTICS_DASHBOARD: `${API_BASE_URL}/reports/analytics/dashboard/`,
  ANALYTICS_GEOGRAPHIC: `${API_BASE_URL}/reports/analytics/geographic/`,

  // Coordinators - Client Assignment
  COORDINATORS_ASSIGN_CLIENT: `${API_BASE_URL}/coordinators/assign-client/`,
  COORDINATORS_CLIENTS: (coordinatorId) => `${API_BASE_URL}/coordinators/${coordinatorId}/clients/`,
  COORDINATORS_ASSIGNMENTS_LIST: `${API_BASE_URL}/coordinators/assignments/`,
  COORDINATORS_ASSIGNMENT_UPDATE: (assignmentId) => `${API_BASE_URL}/coordinators/assignments/${assignmentId}/`,
  COORDINATORS_ASSIGNMENT_DELETE: (assignmentId) => `${API_BASE_URL}/coordinators/assignments/${assignmentId}/`,
  CLIENTS_UNASSIGNED: `${API_BASE_URL}/clients/unassigned/`,
  COORDINATORS_SURVEYS: `${API_BASE_URL}/surveys/my-coordinated/`,
  COORDINATORS_DASHBOARD_STATS: `${API_BASE_URL}/coordinators/dashboard/stats/`,
};

